import { PiBookOpenTextLight } from 'react-icons/pi'

function TMEPublicationTypeIcon({ size = 18, className = '', ...rest }) {
  return (
    <span className={className} {...rest}>
      <PiBookOpenTextLight size={size} />
    </span>
  )
}

export default TMEPublicationTypeIcon
